module.exports = __webpack_public_path__ + "img/banner-tc3.993d1d3e.jpg";